import React, {useEffect, useState} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import ProductTypes from "./ProductTypes";
import {addProductTypeTh, deleteProductTypeTh, getProductTypesTh, updateProductTypeTh} from "../../redux/productTypesReducer";

let mapStateToProps =(state)=>({
    productTypes:state.productTypesPage.productTypes,
    totalElements:state.productTypesPage.totalElements,
})

const ProductTypesContainer = ({getProductTypesTh,productTypes,...props}) => {
    debugger
    let [productList,setProductList]=useState(productTypes)

    useEffect(()=>{
        getProductTypesTh()
    },[])

    useEffect(()=>{
        setProductList(productTypes)
    },[productTypes])
    return (
        <div className="content-wrapper">
            {productList.length>0 &&
                <ProductTypes
                    productTypes={productTypes}
                    {...props}
                />
            }
        </div>
    );
};

export default compose(
    connect(mapStateToProps,{
        getProductTypesTh,
        addProductTypeTh,
        updateProductTypeTh,
        deleteProductTypeTh,

    })
)(ProductTypesContainer);
